


















import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class ArrowUploadIcon extends Vue {
  @Prop({ default: '24' }) readonly width?: string;
  @Prop({ default: '24' }) readonly height?: string;
  @Prop({ default: 'white' }) readonly color?: string;
}
